import { BrokerIntegrationsConfiguration } from '@interhyp/module-broker-integrations-configuration';
import { Configuration } from '@interhyp/module-configuration';
import { MarketingPartnerConfiguration } from '@interhyp/module-marketing-partner-configuration';
import { useAuth } from '@interhyp/util-authentication';
import { useMemo } from 'react';

import '@interhyp/module-configuration/esm/index.css';
import '@interhyp/module-evaluation/esm/index.css';
import '@interhyp/module-credit-configuration/esm/index.css';
import '@interhyp/module-marketing-partner-configuration/esm/index.css';
import '@interhyp/module-broker-integrations-configuration/esm/index.css';
import '@interhyp/module-event-notification/esm/index.css';
import '@interhyp/module-preinquiry-configuration/esm/index.css';
import '@interhyp/plugin-estate-valuation/esm/index.css';

export function ConfigurationNew() {
  const auth = useAuth();

  const configurationSections = useMemo(() => {
    return [BrokerIntegrationsConfiguration, MarketingPartnerConfiguration];
  }, []);

  if (!auth.done) {
    auth.authenticate();
  }

  if (!auth.token) {
    return null;
  }

  return (
    <Configuration
      userId={auth.token.user_id}
      companyId={auth.token.company_id}
      configurationSections={configurationSections}
    />
  );
}
